








import { Input } from './mixins';
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';

@Component
export default class FormBadgeSelect extends Mixins(Input) {
  @Prop({ required: false }) address?: OrderAddress;
}
